
//import '../../scss/master.scss';

import JQuery from 'jquery';
import lottie from 'lottie-web';

import _ from 'underscore';
import disableScroll from 'disable-scroll';


import PhotoSwipeUI_Default from '../../lib/photoswipe-ui-default.min.js';
import PhotoSwipe from '../../lib/photoswipe.min.js';

// for Vue
window.$ = window.JQuery = JQuery;

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


import Swiper, { Autoplay, Navigation, Pagination, Scrollbar } from "swiper";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import MicroModal from 'micromodal';




// 1. header
function headerNavToggle() {
	$(".js-menu-toggle").click(function (e) {
		e.preventDefault();
		if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".main-menu").removeClass("is-active");
			$(".site-header").removeClass("is-fixed");
			$(".dropdown-menu").removeClass("is-active");
			$(".main-menu").removeClass("is-pushed");
		} else {
			$(this).addClass("is-active");
			$(".main-menu").addClass("is-active");
			$(".site-header").addClass("is-fixed");
		}
	});

}

// underline current page
var currentPageIndex = -1;
const menuItems = document.querySelectorAll('.main-menu__sub-item');


for (var i = 0; i < menuItems.length; i++) {
    if (menuItems[i].href === document.URL) {
        currentPageIndex = i;
    }
}

if (currentPageIndex != -1) {
	menuItems[currentPageIndex].classList.add("current-page");
}


/* 2. Lottie animations in hero sections */
if($(".lottie-home-hero").length) {
	var animateHearts = lottie.loadAnimation({
		container: document.getElementById('home-hero-animation'),
		renderer: 'svg',
		loop: true,
		autoplay: true,
		path: '/src/lottie/lottie_blue.json'
	});

	var Webflow = Webflow || [];
	Webflow.push(function() {
		window.addEventListener('resize', function() {
			window.Webflow.require("lottie").lottie.resize();
		});	
	});

}

if($(".lottie-alt-hero").length) {
	var animateHearts = lottie.loadAnimation({
		container: document.getElementById('alt-hero-animation'),
		renderer: 'svg',
		loop: true,
		autoplay: true,
		path: '/src/lottie/lottie_tirkiz.json'
	});

	var Webflow = Webflow || [];
	Webflow.push(function() {
		window.addEventListener('resize', function() {
			window.Webflow.require("lottie").lottie.resize();
		});	
	});

}




/* 2. reveal animations on homepage services section */
function animateServices() {
	// usage:
	ScrollTrigger.batch(".services-list__item-inner", {
	  interval: 0.2, // time window (in seconds) for batching to occur. The first callback that occurs (of its type) will start the timer, and when it elapses, any other similar callbacks for other targets will be batched into an array and fed to the callback. Default is 0.1
	  batchMax: 10,   // maximum batch size (targets)
	  onEnter: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: 0.2, overwrite: true}),
	//   onLeave: batch => gsap.set(batch, {autoAlpha: 0, y: ('100%') , overwrite: true}),
	//   onEnterBack: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: 0.2, overwrite: true}),
	//   onLeaveBack: batch => gsap.set(batch, {autoAlpha: 0, y: ('100%'), overwrite: true})
	  // you can also define things like start, end, etc.
	});

	// usage:
	ScrollTrigger.batch(".services-list__item-separator", {
	  interval: 0.2, // time window (in seconds) for batching to occur. The first callback that occurs (of its type) will start the timer, and when it elapses, any other similar callbacks for other targets will be batched into an array and fed to the callback. Default is 0.1
	  batchMax: 10,   // maximum batch size (targets)
	  onEnter: batch => gsap.to(batch, {scaleX: 1, stagger: 0.2, overwrite: true}),
	//   onLeave: batch => gsap.set(batch, {scaleX: 0 , overwrite: true}),
	//   onEnterBack: batch => gsap.to(batch, {scaleX: 1, stagger: 0.2, overwrite: true}),
	//   onLeaveBack: batch => gsap.set(batch, {scaleX: 0, overwrite: true})
	  // you can also define things like start, end, etc.
	});

}






/* 4. Sliders */

var simpleSwiper = {

	element: '.js-swiper--simple',
	firstLoad: true,
	swiperTabs: undefined,
	map: [],
	tabs: [],

	init: function() {
		var self = this;

		if(self.swiperTabs == undefined){
			this.initSelector();
		}
	},

	destroy: function() {
		var self = this;

		if(self.swiperTabs !== undefined){
			self.swiperTabs.destroy(true, true);
		}
	},

	initSelector: function() {
		var self = this;

		self.swiperTabs = new Swiper('.js-swiper--simple', {
			modules: [Navigation, Pagination, Scrollbar],
			loop: false,
			slidesPerView: "auto",
			// slidesPerView: 1.15,
			spaceBetween: 20,

			navigation: {
                nextEl: ".simple-swiper .swiper-button-next",
                prevEl: ".simple-swiper .swiper-button-prev",
            },
			breakpoints: {
				/*200: {
					slidesPerView: 1.15,
					spaceBetween: 20,
				},*/
				768: {
					// slidesPerView: 2.2,
					spaceBetween: 32,
				},
				/*1800: {
					slidesPerView: 3.2,
					spaceBetween: 32,
				},

				2500: {
					slidesPerView: "auto",
					spaceBetween: 32,
				},*/
			},

			init: function(swiper) {
				this.slideTo(getSlideIndexByClass('current'));
			},
		});
	},
};




var teamSwiper = {

	element: '.js-swiper--team',
	firstLoad: true,
	swiperTabs: undefined,
	map: [],
	tabs: [],

	init: function() {
		var self = this;

		if(self.swiperTabs == undefined){
			this.initSelector();
		}
	},

	destroy: function() {
		var self = this;

		if(self.swiperTabs !== undefined){
			self.swiperTabs.destroy(true, true);
		}
	},

	initSelector: function() {
		var self = this;

		self.swiperTabs = new Swiper('.js-swiper--team', {
			modules: [Navigation, Pagination, Scrollbar],
			loop: false,
			slidesPerView: "auto",
			spaceBetween: 16,

			navigation: {
                nextEl: ".team-swiper .swiper-button-next",
                prevEl: ".team-swiper .swiper-button-prev",
            },
			breakpoints: {
				768: {
					spaceBetween: 28,
				}
			},

			init: function(swiper) {
				this.slideTo(getSlideIndexByClass('current'));
			},
		});
	},
};


var teamModalSwiper = {

	element: '.js-swiper--team-modal',
	firstLoad: true,
	swiperTabs: undefined,
	map: [],
	tabs: [],

	init: function() {
		var self = this;

		if(self.swiperTabs == undefined){
			this.initSelector();
		}
	},

	destroy: function() {
		var self = this;

		if(self.swiperTabs !== undefined){
			self.swiperTabs.destroy(true, true);
		}
	},

	initSelector: function() {
		var self = this;

		self.swiperTabs = new Swiper('.js-swiper--team-modal', {
			modules: [Navigation, Pagination, Scrollbar],
			loop: false,
			slidesPerView: 1.2,
			spaceBetween: 17,
			centeredSlides: true,

			navigation: {
                nextEl: ".team-modal-swiper .swiper-button-next",
                prevEl: ".team-modal-swiper .swiper-button-prev",
            },
			
			breakpoints: {
				1440: {
					slidesPerView: 1.44,
					spaceBetween: 150,
				},
				/*1800: {
					slidesPerView: 1.75,
					spaceBetween: 150,
				},*/

				/*2500: {
					spaceBetween: 28,
				},*/
			},

			init: function(swiper) {
				this.slideTo(getSlideIndexByClass('current'));
			},
		});
	},
};

var clientsMobileSwiper = {

	element: '.js-swiper--clients',
	firstLoad: true,
	swiperTabs: undefined,
	map: [],
	tabs: [],

	init: function() {
		var self = this;

		if(self.swiperTabs == undefined){
			this.initSelector();
		}
	},

	destroy: function() {
		var self = this;

		if(self.swiperTabs !== undefined){
			self.swiperTabs.destroy(true, true);
		}
	},

	initSelector: function() {
		var self = this;

		self.swiperTabs = new Swiper('.js-swiper--clients', {
			modules: [Autoplay, Pagination],
			loop: true,
			slidesPerView: 3,
			spaceBetween: 20,
			centeredSlides: true,
			autoplay: {
				delay: 2500,
				disableOnInteraction: false, 
			},

			pagination: {
				el: '.clients-swiper-pagination',
				clickable: true,
				renderBullet: function (index, className) {
				if (index < 4) { 
					return '<span class="' + className + '">' + '</span>';
				} else if (index === 4) {
					return '<span class="' + className + '"></span>';
				} else {
					return ''; 
				}
				},
			},

			init: function(swiper) {
				this.slideTo(getSlideIndexByClass('current'));
			},
		});
	},
};



function servicesReadMore() {
	$(".js-read-more").click(function (e) {
		e.preventDefault();
		$(this).parent().find(".services-pr__body").slideDown();
		$(this).parent().find(".js-read-less").show();
		$(this).hide();
	});

	$(".js-read-less").click(function (e) {
		e.preventDefault();
		$(this).parent().find(".services-pr__body").slideUp();
		$(this).parent().find(".js-read-more").show();
		$(this).hide();
	});

}


function animateFrom(elem, direction) {
	direction = direction || 1;
	var x = 0,
	y = direction * 100;
	if(elem.classList.contains("gs-reveal--from-left")) {
		x = -100;
		y = 0;
	} else if (elem.classList.contains("gs-reveal--from-right")) {
		x = 100;
		y = 0;
	}
	elem.style.transform = "translate(" + x + "px, " + y + "px)";
	elem.style.opacity = "0";
	gsap.fromTo(elem, {x: x, y: y, autoAlpha: 0}, {
		duration: 1.25, 
		x: 0,
		y: 0, 
		autoAlpha: 1, 
		ease: "expo", 
		overwrite: "auto"
	});
}

function hide(elem) {
	gsap.set(elem, {autoAlpha: 0});
}

document.addEventListener("DOMContentLoaded", function() {
	gsap.registerPlugin(ScrollTrigger);

	gsap.utils.toArray(".gs-reveal").forEach(function(elem) {
	    hide(elem); // assure that the element is hidden when scrolled into view
	    
	    ScrollTrigger.create({
	    	trigger: elem,
	    	start: "top 90%",
			once: true, 
	    	// end: '50%',
	    	// markers: true,
	    	onEnter: function() { animateFrom(elem) }, 
	    	// onEnterBack: function() { animateFrom(elem, -1) },
	      	// onLeave: function() { hide(elem) } // assure that the element is hidden when scrolled into view
	  });
	});
});









// 5. Vudu js

// pswp
var NivasPhotoSwipe = {

	pswpElement: false,

	init: function() {
		this.pswpElement = document.querySelectorAll('.pswp')[0];
		this.bindGallery();
		this.bindVideo();

	},

	openOverlay: function(images, optionz) {


		var self = this;
		var userOptions = (optionz!==undefined) ? optionz : {};

		var options = {

			overtitle: false,
			title: false,

			index: 0,
			modal: true,
			history: false,
			loop: true,

			// Buttons/elements
			closeEl: true,
			captionEl: true,
			fullscreenEl: false,
			zoomEl: false,
			shareEl: false,
			//trebalo bib biti true za kajzericu
			//counterEl: true,
			counterEl: false,
			arrowEl: true,
			preloaderEl: false,

			// close
			escKey: true,
			pinchToClose: false,
			tapToClose: true,
			closeOnVerticalDrag: false,
			verticalDragRange: 1,
			clickToCloseNonZoomable: false,
			closeOnScroll: false,

			showAnimationDuration: 500,
			hideAnimationDuration: 200
		};


		_.extend(options, userOptions);


		var gallery = new PhotoSwipe( self.pswpElement, PhotoSwipeUI_Default, images, options);
		gallery.init();
		gallery.listen('close', function() {
			$(".pswp__container .pswp__item").html("");
		});


		$(".pswp .pswp__head").hide();
		if(options.overtitle || options.title)
		{
			$(".pswp .pswp__head").show();
			$(".pswp .galleryName").html(options.overtitle);
			$(".pswp .galleryDesc").html(options.title);
		}

		return gallery;
	

	},

	openVideoOverlay: function(html, title, userOptions) {

		disableScroll.on();


		var self = this;

		html = html===undefined ? '' : html;
		title = title===undefined ? '' : title;

		var userOptions = (userOptions!==undefined && typeof object) ? userOptions : {};
		var options = {
			index: 0,
			modal: true,
			history: false,
			loop: true,

			// Buttons/elements
			closeEl: true,
			captionEl: true,
			fullscreenEl: false,
			zoomEl: false,
			shareEl: false,
			counterEl: false,
			arrowEl: false,
			preloaderEl: false,

			// close
			escKey: false,
			pinchToClose: false,
			tapToClose: true,
			closeOnVerticalDrag: false,
			verticalDragRange: 1,
			clickToCloseNonZoomable: false,
			closeOnScroll: false,

			showAnimationDuration: 500,
			hideAnimationDuration: 200
		};
		_.extend(options, userOptions);


		var items = [{html: html, title: title}];

		var gallery = new PhotoSwipe( self.pswpElement, PhotoSwipeUI_Default, items, options);
		gallery.init();
		gallery.listen('close', function() {
			$(".pswp__container .pswp__item").html("");
			disableScroll.off();
		});





		return gallery;
	},

	bindVideo: function() {

		if($(".js-trigger-video").length)
		{
			var self = this;

			$(".js-trigger-video").on("click touchtap", function(e){
				e.preventDefault();

				var html = $(this).find(".js-video-iframe").html();
				var title = $(this).find(".js-video-iframe").attr("data-title");
				self.openVideoOverlay(html, title);
			});
		}

		if($(".js-trigger-video-gallery").length)
		{
			var self = this;

			$(".js-trigger-video-gallery").on("click touchtap", function(e){
				e.preventDefault();

				$(".multimedia__item video").each(function(index, item){
					item.pause();
				});

				/*var html = $(this).find(".js-video-iframe").html();
				var title = $(this).find(".js-video-iframe").attr("data-title");
				var pswp = self.openVideoOverlay(html, title);
				pswp.listen('close', function() {
					$(".intro--index video").each(function(index, item){
						item.play();
					});
				});*/

				self.iframes = {};

				var videoContainer = $(this).attr("data-container");
				var pswpElement = document.querySelectorAll('.pswp')[0];
				console.log (videoContainer, 'videoContainer')

				var videos = [];
				$(videoContainer + " .item").each(function(item, index){

					var video = {};
					video.html = $(this).find(".js-video-iframe").html();
					video.title = $(this).find(".js-video-iframe").attr("data-title");
					video.author = "";

					videos.push(video);
				});


				var idx = $(videoContainer + " .item").index(this);

				var options = {
					index: idx,
					history: false,
					closeOnScroll: false,
					overtitle: $(this).attr("data-overtitle"),
					title: $(this).attr("data-title")
				};


				// ga tracking
				//BaskaGtmTracking.trackEvent('Video Gallery', 'open', options.title, 1);

				var pswp = self.openOverlay(videos, options);
				pswp.listen('close', function() {
					$(".intro--index video").each(function(index, item){
						item.play();
					});
				});

			});



			$(document).on("click touchtap", ".js-video", function(e){
				e.preventDefault();

				$(".multimedia__item video").each(function(index, item){
					item.pause();
				});

				self.iframes = {};

				var videoContainer = $(this).closest(".pswp_gallery").find(".multimedia__link").attr("data-container");
				// console.log (videoContainer, 'videoContainer')
				var pswpElement = document.querySelectorAll('.pswp')[0];

				var videos = [];
				$(videoContainer + " .item").each(function(item, index){
					// console.log(this);

					var video = {};
					video.html = $(this).find(".js-video-iframe").html();
					video.title = $(this).find(".js-video-iframe").attr("data-title");
					video.author = "";

					videos.push(video);
				});

				var idx = $(videoContainer + " .item").index(this);

				var options = {
					index: idx,
					history: false,
					closeOnScroll: false,
					overtitle: $(this).attr("data-overtitle"),
					title: $(this).attr("data-title")
				};

				self.openOverlay(videos, options);

			});


		}



	},

	bindGallery: function() {

		var self = this;

		$(document).on("click touchtap", ".js-trigger-gallery", function(e){
			e.preventDefault();
			var imageContainer = $(this).attr("data-container");

			var images = [
				{
					src: '/src/img/demo/article/gallery-bg.jpg',
					w: 600,
					h: 400
				},
				{
					src: '/src/img/demo/article/gallery-bg.jpg',
					w: 800,
					h: 800
				}
			];

			$(imageContainer + " .item").each(function(item, index){

				var wh = $(this).attr("data-wh").split("x");
				var $img = $(this).find("img");

				var img = {};
				img.src = $(this).attr("href");
				img.w = wh[0];
				img.h = wh[1];
				img.title = ($img.attr("alt")===undefined) ? "" : $img.attr("alt");
				img.author = ($img.attr("data-author")===undefined) ? "" : $img.attr("data-author");

				images.push(img);

			});


			var idx = $(imageContainer + " .item").index(this);

			var options = {
				index: idx,
				history: false,
				closeOnScroll: false,
				overtitle: $(this).attr("data-overtitle"),
				title: $(this).attr("data-title"),
				addCaptionHTMLFn: function(item, captionEl, isFake) {
					if(!item.title) {
						captionEl.children[0].innerText = '';
						return false;
					}
					captionEl.children[0].innerHTML = item.title +  '<br/><small>Autor: ' + item.author + '</small>';
					return true;
				}
			};

			// ga tracking
			//BaskaGtmTracking.trackEvent('Image Gallery', 'open', options.title, 1);

			self.openOverlay(images, options);

		});

		$(document).on("click touchtap", ".js-image", function(e){
			e.preventDefault();

			console.log('js-img');

			var $imageContainer = $(this).closest(".pswp_gallery");

			var images = [];
			$imageContainer.find(".js-image").each(function(index, item){

				var wh = $(this).attr("data-wh").split("x");
				var $img = $(this).find("img");

				var img = {};
				img.src = $(this).attr("href");
				img.w = wh[0];
				img.h = wh[1];
				img.title = ($img.attr("alt")===undefined || $img.attr("alt") == "") ? "&nbsp;" : $img.attr("alt") + '<br>';
				img.author = ($img.attr("data-author")===undefined) ? "" :  '<small>Autor: ' + $img.attr("data-author") + '</small>' ;
				img.index = index;


				images.push(img);

			});

			var idx = $imageContainer.find(".js-image").index(this);

			var options = {
				index: idx,
				history: false,
				closeOnScroll: false,
				overtitle: $imageContainer.attr("data-overtitle"),
				title: $imageContainer.attr("data-title"),
				addCaptionHTMLFn: function(item, captionEl, isFake) {

					if(item.title === false) {
						captionEl.children[0].innerText = '';
						return false;
					}

					captionEl.children[0].innerHTML = item.title + item.author;
					return true;
				}
			};

			// ga tracking
			//BaskaGtmTracking.trackEvent('Image Gallery', 'open', options.title, 1);

			self.openOverlay(images, options);

		});

	},
}


var xLoadMore = {
	init:()=>{
		$(document).on('click touchstart', '.js-load-more', function(e){
			e.preventDefault();

			var button = $(this);
			var selector = $(this).data("container");
			var tgt = $(selector);

			$.ajax({
				url:"/"+langCode+"/xajax/load_more",
				type:"POST",
				data:{
					pg:button.data('pg'),
					sec:button.data('sec'),
					tpl:button.data('tpl'),
				},
				dataType:'json',
				success:function(res)
				{
					if (res.next)
					{
						pg = parseInt(button.data('pg')) + 1;
						button.data('pg', pg);
					}
					else
					{
						button.hide();
					}
					tgt.append(res.html);
					// animateCards();
				}
			});
		})
	}
}



// product modals
document.addEventListener("DOMContentLoaded", function() {

	if ( $('.js-team-micromodal').length) {

		MicroModal.init({
			awaitCloseAnimation: true,
			onShow: function(modal) {
				// console.log("micromodal open");
			},
			onClose: function(modal) {
				// console.log("micromodal close");
			},
			disableScroll: true, // [6]
			disableFocus: true, // [7]
		});


		// slide to same swiper slide in modal that was clicked outside
		$('.team-swiper__link').click(function(event) {
			// MicroModal.show('js-team-micromodal');
			// console.log(this)
			// console.log($(this).data("slider"), "slide index number")
			var self = this;
			var indexNumber = $(this).data("slider");
			teamModalSwiper.swiperTabs.slideTo(indexNumber);
		});


	}

});



/* Vudu JS */

// gdpr
var VuduGdprPlugin = {


	options: {
		'necessary': {
			cookieName: 'gdpr_level_1_necessary',
			pristine: true,
			disabled: true,
			checked: true,
			el: 'gdpr_settings_choice_necessary'
		},
		'analytical': {
			cookieName: 'gdpr_level_2_analytical',
			pristine: true,
			disabled: false,
			checked: false,
			el: 'gdpr_settings_choice_analytical'
		},
		'marketing': {
			cookieName: 'gdpr_level_3_marketing',
			pristine: true,
			disabled: false,
			checked: false,
			el: 'gdpr_settings_choice_marketing'
		}
	},

	init: function () {


		if ($('#gdpr_toolbar').length) {
			this.bindEvent();

			var pristine = true;
			for (var i in VuduGdprPlugin.options) {
				var usersSelection = VuduGdprPlugin.options[i];

				var cookieValue = VuduGdprPlugin.getCookie(usersSelection.cookieName);
				if (cookieValue == 1) {
					pristine = false;

					if (usersSelection.disabled === false) {
						VuduGdprPlugin.options[i].checked = true;

						$("#" + usersSelection.el).prop("checked", true);
					}
				}
				else if (cookieValue == 0) {
					pristine = false;

					if (usersSelection.disabled === false) {
						VuduGdprPlugin.options[i].checked = false;

						$("#" + usersSelection.el).prop("checked", false);
					}
				}

			}

			if (pristine == false) {
				$("#js-toogle-gdpr").addClass("show");
				VuduGdprPlugin.hideToolbar();
			}
            else
			{
				$("#gdpr_toolbar").removeClass("hide");
			}
		}


	},

	bindEvent: function () {

		$('#gdpr_toolbar .x_submit_necessary').on("click", function (e) {
			e.preventDefault();

			VuduGdprPlugin.consentCookie('necessary', true);
			$('#gdpr_settings_choice_necessary').prop("checked", true);
			VuduGdprPlugin.consentCookie('analytical', false);
			$('#gdpr_settings_choice_analytical').prop("checked", false);
			VuduGdprPlugin.consentCookie('marketing', false);
			$('#gdpr_settings_choice_marketing').prop("checked", false);

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});
      
      
		$('#gdpr_toolbar .x_submit_all').on("click", function (e) {
			e.preventDefault();

			VuduGdprPlugin.consentCookie('necessary', true);
			$('#gdpr_settings_choice_necessary').prop("checked", true);
			VuduGdprPlugin.consentCookie('analytical', true);
			$('#gdpr_settings_choice_analytical').prop("checked", true);
			VuduGdprPlugin.consentCookie('marketing', true);
			$('#gdpr_settings_choice_marketing').prop("checked", true);

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});

		$('#gdpr_toolbar a.x_open_setup').on("click", function (e) {
			e.preventDefault();

			$('#gdpr_toolbar .gdpr-prompt__ctrl').toggleClass('active');
			$(this).toggleClass('active');
			$('#gdpr_settings_popup').toggleClass('show');
			$('.gdpr-msg').toggleClass('show');
		});

		$('#js-toogle-gdpr').on("click", function (e) {
			e.preventDefault();

			$('#gdpr_toolbar .gdpr-prompt__ctrl').removeClass('active');
			VuduGdprPlugin.showToolbar();
		});

		$("#gdpr_toolbar .x_submit_selected").on("click", function (e) {
			e.preventDefault();

			$("#gdpr_toolbar input.gdpr_level").each(function (index, item) {
				var name = $(item).val();
				var checked = $(this).prop("checked");
				VuduGdprPlugin.consentCookie(name, checked);
			});

			$('#gdpr_toolbar .gdpr-prompt__ctrl').removeClass('active');
			$('#gdpr_toolbar a.x_open_setup').removeClass('active');

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});
	},

	showToolbar: function () {
		$("#gdpr-overlay").show();
		$("#gdpr_toolbar").removeClass('hide');
	},

	hideToolbar: function () {
		$("#gdpr-overlay").hide();
		$("#gdpr_toolbar").addClass('hide');
	},

	consentCookie: function (name, checked) {

		if (VuduGdprPlugin.options[name] !== undefined) {
			var value = checked ? 1 : 0;
			VuduGdprPlugin.setCookie(VuduGdprPlugin.options[name].cookieName, value, 365);
		}
	},

	consentAllCookie: function () {

		for (var i in VuduGdprPlugin.options) {
			var usersSelection = VuduGdprPlugin.options[i];
			VuduGdprPlugin.consentCookie(usersSelection.cookieName, true);
		}
	},

	setLevel: function (lvl) {

		if (typeof (cookieDomainName) != 'undefined' && cookieDomainName) {
			//$.cookie(VuduGdprPlugin.cookieName, lvl, { expires: 365, path: '/', domain: cookieDomainName });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, lvl, 365, cookieDomainName);
		}
		else {
			//$.cookie(VuduGdprPlugin.cookieName, lvl, { expires: 365, path: '/' });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, lvl, 365);
		}
	},

	setMaxLevel: function () {

		if (typeof (cookieDomainName) != 'undefined' && cookieDomainName) {
			//$.cookie(VuduGdprPlugin.cookieName, 4, { expires: 365, path: '/', domain: cookieDomainName });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, 4, 365, cookieDomainName);
		}
		else {
			//$.cookie(VuduGdprPlugin.cookieName, 4, { expires: 365, path: '/' });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, 4, 365);
		}
	},

	setCookie: function (cname, cvalue, exdays, domain) {
		var domain = (typeof (domain) != 'undefined' && domain) ? domain : '.';
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var cookieExpires = "expires=" + d.toUTCString();
		var cookieDomain = "domain=" + domain;
		//document.cookie = cname + "=" + cvalue + ";" + cookieExpires + ";" + cookieDomain + ";path=/";
		document.cookie = cname + "=" + cvalue + ";" + cookieExpires;
	},

	getCookie: function (cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return null;
	}

}



$(document).ready(function() {
	console.log('App ready!');

	VuduGdprPlugin.init();
	headerNavToggle();
	simpleSwiper.init();
	clientsMobileSwiper.init();
	teamSwiper.init();
	teamModalSwiper.init();
	servicesReadMore();
	NivasPhotoSwipe.init();
	
	xLoadMore.init();

	animateServices();


});

// scale mobile client logos
// function logoResize() {
// 	document.addEventListener("DOMContentLoaded", function() {
// 		document.querySelectorAll('.clients-list__logo').forEach(logo => {
// 			console.log(logo.offsetWidth);
// 			logo.style.width = logo.offsetWidth * .7 + 'px';
// 		} )
// 	});
// }

// if (document.querySelector('.clients-list') && document.querySelector('body').offsetWidth < 768) {
// 	console.log('resize ran');
// 	console.log(document.querySelector('body').offsetWidth);
// 	logoResize();
// }

window.addEventListener('hashchange', offsetAnchor);
window.setTimeout(offsetAnchor, 1);
function offsetAnchor() {
	if (location.hash.length !== 0) {
		window.scrollTo(window.scrollX, window.scrollY - 100);
	}
}
